import { render, staticRenderFns } from "./AIConsult.vue?vue&type=template&id=45c4a50c&scoped=true&"
import script from "./AIConsult.vue?vue&type=script&lang=js&"
export * from "./AIConsult.vue?vue&type=script&lang=js&"
import style0 from "./AIConsult.vue?vue&type=style&index=0&id=45c4a50c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c4a50c",
  null
  
)

export default component.exports